import * as API from '@/services/API';

export default {
  setTheme({ commit }, theme) {
    localStorage.setItem('theme', theme);
    commit('SET_THEME', theme);
  },

  async update({ commit }, payload) {
    var data = new FormData();
    delete payload.domain_verified;
    for (var key in payload) {
      data.append(key, payload[key]);
    }
    data.append('_method', 'PUT');
    return await API.apiClient
      .post('/websites/' + payload.id, data)
      .then((response) => {
        commit('SET_THEME', response.data.theme.path);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async updatePages({ commit, dispatch }, pages) {
    let flag = true; // Flag variable
    await Promise.all(
      Object.values(pages).map(async (page) => {
        var data = new FormData();
        delete page.widgets;
        for (var key in page) {
          if (page[key] == 'null' || page[key] == null) {
            page[key] = '';
          }
          data.append(key, page[key]);
        }
        data.append('_method', 'PUT');

        try {
          await API.apiClient.post('/pages/' + page.id, data);
        } catch (error) {
          commit('SET_ERROR', error, { root: true });
          flag = false; // Set flag to false if an error occurs
        }
      })
    );
    // Call the get function after updating all pages
    await dispatch('get');

    return flag; // Return the flag value
  },

  async get({ commit }) {
    return await API.apiClient
      .get('/websites')
      .then((response) => {
        commit('SET_WEBSITE', response.data);
        commit('SET_THEME', response.data.theme.path);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  themes({ commit }) {
    return API.apiClient
      .get('/themes')
      .then((response) => {
        commit('SET_THEMES', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async addWidget({ commit, dispatch }, payload) {
    console.log(payload);
    return await API.apiClient
      .post('/pages/' + payload.page_id + '/widgets', payload)
      .then((response) => {
        dispatch('get');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async updateWidget({ commit, dispatch }, payload) {
    return await API.apiClient
      .put('/pages/' + payload.page_id + '/widgets/' + payload.id, payload)
      .then((response) => {
        dispatch('get');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  dnsValidate({ commit, rootGetters }, domain) {
    let website = rootGetters['website/website'].id;
    return API.apiClient
      .post('/websites/' + website + '/verify', { domain: domain })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
